export default "__VITE_ASSET__DABfpTZD__"